<app-import-file (fileUrlEmmiter)="listener($event)" [fromCampaign]="true"></app-import-file>
<button mat-raised-button color="primary" [mat-dialog-close]="data.url" cdkFocusInitial>Ok</button>